/**
 * LeadsGate — the flag-gated mount swap for the Leads "Lenses" pilot
 * (AD-046, Phase A final step). Reads the signed-in role and renders the new
 * <LeadsLenses/> switcher shell ONLY when `leadsLensesEnabled(role)` is true
 * for that user (admin/staff who have opted in via ?lenses=1 / localStorage).
 * Everyone else — and every flag-off session — renders today's <Leads/>
 * byte-for-byte, so the live screen is completely untouched until opt-in.
 */
import { useAuth } from '../lib/auth';
import { leadsLensesEnabled } from '../lib/featureFlags';
import Leads from './Leads';
import LeadsLenses from './LeadsLenses';

export default function LeadsGate() {
  const { role } = useAuth();
  return leadsLensesEnabled(role) ? <LeadsLenses /> : <Leads />;
}
